import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  AppBar,
  Toolbar,
  Button,
  Box,
  Menu,
  MenuItem,
} from '@mui/material';
import { useAuth } from '../context/AuthContext';

const Navigation: React.FC = () => {
  const navigate = useNavigate();
  const { user, logout } = useAuth();
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

  const handleMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = async () => {
    await logout();
    navigate('/login');
    handleMenuClose();
  };

  const renderNavigation = () => {
    switch (user?.role) {
      case 'customer':
        return (
          <>
            <Button color="inherit" onClick={() => navigate('/customer/inquiries')}>
              Meine Anfragen
            </Button>
          </>
        );
      case 'contractor':
        return (
          <>
            <Button color="inherit" onClick={() => navigate('/contractor/browse-jobs')}>
              Verfügbare Aufträge
            </Button>
            <Button color="inherit" onClick={() => navigate('/contractor/my-leads')}>
              Meine Leads
            </Button>
          </>
        );
      case 'admin':
      case 'staff':
        return (
          <>
            <Button color="inherit" onClick={() => navigate('/admin/dashboard')}>
              Dashboard
            </Button>
            <Button color="inherit" onClick={() => navigate('/admin/inquiries')}>
              Ausschreibungen
            </Button>
            <Button color="inherit" onClick={() => navigate('/admin/callbacks')}>
              Rückrufe
            </Button>
            <Button color="inherit" onClick={() => navigate('/admin/users')}>
              Benutzer
            </Button>
            <Button color="inherit" onClick={() => navigate('/admin/contractors')}>
              Dienstleister
            </Button>
            <Button color="inherit" onClick={() => navigate('/admin/payments')}>
              Zahlungen
            </Button>
            <Button color="inherit" onClick={() => navigate('/admin/form-config')}>
              Formular
            </Button>
            <Button color="inherit" onClick={() => navigate('/admin/content')}>
              Inhalte
            </Button>
            <Button color="inherit" onClick={() => navigate('/admin/settings')}>
              Einstellungen
            </Button>
          </>
        );
      default:
        return null;
    }
  };

  return (
    <AppBar position="static">
      <Toolbar>
        <Box
          sx={{ flexGrow: 1, cursor: 'pointer', display: 'flex', alignItems: 'center' }}
          onClick={() => navigate('/')}
        >
          <img
            src="/callcenter-suche-logo.png"
            alt="Callcenter-Suche"
            style={{ height: 40, width: 'auto', display: 'block' }}
          />
        </Box>

        <Box sx={{ display: 'flex', gap: 2 }}>
          {renderNavigation()}

          <Button
            color="inherit"
            onClick={handleMenuOpen}
          >
            {user?.name}
          </Button>

          <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={handleMenuClose}
          >
            <MenuItem onClick={() => { navigate('/profile'); handleMenuClose(); }}>
              Mein Profil
            </MenuItem>
            <MenuItem onClick={() => { navigate('/account-settings'); handleMenuClose(); }}>
              Kontoeinstellungen
            </MenuItem>
            <MenuItem onClick={handleLogout}>Abmelden</MenuItem>
          </Menu>
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default Navigation;
